export const expenseKeys = {
  all: ["expenses"] as const,
  lists: () => [...expenseKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...expenseKeys.lists(), filters] as const,
  details: () => [...expenseKeys.all, "detail"] as const,
  detail: (id: string) => [...expenseKeys.details(), id] as const,
  categories: () => [...expenseKeys.all, "categories"] as const,
  totals: (filters: Record<string, unknown>) => [...expenseKeys.all, "totals", filters] as const,
  categoryTotals: (filters: Record<string, unknown>) =>
    [...expenseKeys.all, "category-totals", filters] as const,
};

export const recurringTemplateKeys = {
  all: ["recurring-templates"] as const,
  lists: () => [...recurringTemplateKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...recurringTemplateKeys.lists(), filters] as const,
  details: () => [...recurringTemplateKeys.all, "detail"] as const,
  detail: (id: string) => [...recurringTemplateKeys.details(), id] as const,
  stats: () => [...recurringTemplateKeys.all, "stats"] as const,
};
